import { StyledAlert } from "./styles";

const Alert = ({
  show = false,
  onClose,
  isDismissible = false,
  heading = "",
  message,
  description,
  type = 'warning', // success, info, warning, error
  children,
  closable,
  ...rest
}) => {

    


  return (
    <>
      {/* <StyledAlert show={show} variant={variant} onClose={onClose} dismissible={isDismissible} {...rest}>
        {heading && <Alert.Heading>{heading}</Alert.Heading>}
        {children}
      </StyledAlert> */}

      {show && <StyledAlert 
      message={message} 
      description={description} 
      type={type} 
      closable={closable || isDismissible} 
      {...rest}/> }

      
    </>
  );
};

export default Alert;
